//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tableList, fileDownload, getNoticeList as _getNoticeList, bpmnStuAndteachStastic } from "@/api/portrayal/policy";
import { getUser } from "@/api/management/user";
import { stuAndteachStastic } from "@/api/home/home";
import schoolDate from "@/components/management/showcase/childModules/SchoolDate";
import note from "@/components/management/showcase/childModules/Note";
import schedule from "@/components/management/showcase/childModules/Schedule";
import affair from "@/components/management/showcase/childModules/affair";
import { getCardList } from "@/api/managementCenter/specialManage";
export default {
  name: "CARD",
  components: {
    schoolDate: schoolDate,
    note: note,
    schedule: schedule,
    affair: affair
  },
  props: ["moduleData"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      collectList: [],
      policyFileList: [],
      noticeList: [],
      stasticList: []
    };
  },
  computed: {},
  created: function created() {
    // this.getPolicyFileList();
    // this.getNoticeList();
    this.getCardData("0");
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    getCardData: function getCardData(type) {
      var _this = this;

      var params = {
        type: type || ""
      };
      getCardList(params).then(function (res) {
        if (type == "0") {
          _this.noticeList = res.data.data.records;
        }

        if (type == "1") {
          _this.policyFileList = res.data.data.records;
        }
      });
    },
    handleWidth: function handleWidth(col) {
      switch (col) {
        case 1:
          return "100%";

        case 2:
          return "50%";

        case 3:
          return "33.3%";

        case 4:
          return "25%";

        case 5:
          return "20%";

        case 6:
          return "16.6%";

        default:
          return "50%";
      }
    },
    clickServeItem: function clickServeItem(item) {
      var _this2 = this;

      switch (item.serveType) {
        case 0:
          this.$router.push({
            path: "/serveSearch/".concat(item.id, "/").concat(item.interfaceUrl)
          });
          break;

        case 1:
          this.$router.push({
            path: "/serveApproval/".concat(item.id)
          });
          break;

        case 2:
          this.$router.push({
            path: "/serveCustomized/".concat(item.id, "/").concat(item.interfaceUrl)
          });
          break;

        case 9:
          this.$http.post("/statistical/serverInsert", this.$qs.stringify({
            serviceId: item.id,
            appType: 9
          })).then(function () {}).catch(function () {});
          this.url = item.linkUrl;
          this.$nextTick(function () {
            _this2.$refs.url.click();
          });
          break;

        default:
          break;
      }
    },
    iconClick: function iconClick(val) {
      val == "TINFO_NOTICE" ? this.getCardData("0") : this.getCardData("1");
    },
    //校内公文
    getPolicyFileList: function getPolicyFileList() {
      var _this3 = this;

      tableList({
        current: 1,
        size: 5
      }).then(function (_ref) {
        var data = _ref.data;
        _this3.policyFileList = data.data.records;
      });
    },
    //通知公告
    getNoticeList: function getNoticeList() {
      var _this4 = this;

      _getNoticeList({
        len: 5,
        pos: 0
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this4.noticeList = data.data;
        } else {
          _this4.$message.error(data.msg);
        }
      });
    },
    goHref: function goHref(item, path) {
      var routeData = this.$router.resolve({
        name: path,
        query: {
          id: item.ntiId || item.id,
          fileId: item.fileId || "",
          type: item.ntiType || ""
        }
      });
      window.open(routeData.href);
    },
    goPagination: function goPagination(code) {
      var type = code === "TINFO_POLICY_FILE" ? "file" : "notice";
      var routeData = this.$router.resolve({
        name: "/noticesAndFilesPagination",
        query: {
          type: type
        }
      });
      window.open(routeData.href);
    }
  },
  watch: {},
  filters: {}
};